/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { useMantineTheme, rem, Text, Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { useTeamName } from '@fai/friendli-suite/features/settings/team-settings/use-team';
import TeamAvatar from '@fai/ui/components/avatar/team';
import { TextVariants } from '@fai/ui/components/typography/variants';

export function CurrentTeamProfileSection({ teamId }: { teamId: string }) {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const { teamName } = useTeamName(teamId);

  return (
    <>
      <Text
        c={theme.pf.color.fg.neutral.subtle}
        p={`${theme.pf.layout.xs} 0 ${theme.pf.layout['3xs']} ${theme.pf.layout.xs}`}
        variant={TextVariants.Title2Xs}
      >
        {t('layout.team')}
      </Text>
      <Group gap={theme.pf.layout['3xs']} px={theme.pf.layout.xs} py={rem(10)} wrap="nowrap">
        <TeamAvatar size={20} />
        <Text c={theme.pf.color.fg.neutral.strong} truncate={true} variant={TextVariants.BodyMd}>
          {teamName ?? '-'}
        </Text>
      </Group>
    </>
  );
}
